'use client'

// libraries
import { createContext, useContext, ReactNode } from 'react'
import { useForm, UseFormReturn, FieldValues, SubmitHandler } from 'react-hook-form'

// types
interface FormContextType {
	form: UseFormReturn<FieldValues>
}

export const FormContext = createContext<FormContextType | null>(null)

export const useFormContext = () => {
	const context = useContext(FormContext)
	if (!context) {
		throw new Error('useFormContext must be used within a Form component')
	}
	return context
}

interface FormProps {
	className?: string
	action?: string
	method?: 'get' | 'post'
	onSubmit?: SubmitHandler<FieldValues>
	noValidate?: boolean
	children?: ReactNode
}

export default function Form({
	className,
	action,
	method,
	onSubmit,
	noValidate = false,
	children
}: FormProps) {
    
	const form = useForm({ 
		mode: 'onChange',
		reValidateMode: 'onChange'
	})

	const handleSubmit = form.handleSubmit((data) => {
		onSubmit?.(data)
	})

	return (
		<FormContext.Provider value={{ form }}>
			<form
				className={className}
				action={action}
				method={method}
				onSubmit={handleSubmit}
				noValidate={noValidate}
			>
				{children}
			</form>
		</FormContext.Provider>
	)
}